// extracted by mini-css-extract-plugin
module.exports = {"main":"layout-module--main--2OuwJ","mainFixed":"layout-module--main--fixed--1MAB-"};